// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"f6bbb6ec","770":"905ac837","954":"3ad1f5be"}[chunkId] + ".chunk.css";
};